// App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { initFirebase } from './firebaseClient';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './theme/ThemeProvider';
import DashboardLayout from "./layouts/DashboardLayout";
import BattleAnalyzer from './pages/BattleAnalyzer';
import RaidJobAverages from './pages/RaidJobAverages';
import GuidePage from './pages/GuidePage';
import PartyGuidePage from './pages/PartyGuidePage';
import RaidLobby from './pages/RaidLobby';
import PartyPage from './pages/PartyPage';
import ReportIssuePage from './pages/ReportIssue';
import Faq from './pages/Faq';
import Home from './pages/Home';

initFirebase({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<DashboardLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/my" element={<BattleAnalyzer />} />
              <Route path="/stats" element={<RaidJobAverages />} />
              <Route path="/lobby" element={<RaidLobby />} />
              <Route path="/party/:code" element={<PartyPage />} />
              <Route path="/report" element={<ReportIssuePage />} />
              <Route path="/faq" element={<Faq />} />
            </Route>
            <Route path="/guide" element={<GuidePage />} />
            <Route path="/guide2" element={<PartyGuidePage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
